import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { Box, Button, DashboardModule } from '@domain-group/suit-theme'

import type { TaskListItemModel } from '@domain-group/realhub-backend-api-types'

import useTaskListItems from '@hooks/useTaskListItems'

import defaultRequestOptions from '@sections/Admin/packs/Projects/defaultRequestOptions'

import SubTask from './SubTask'

interface SubTasksProps {
  callbacks: {
    addSubTask: () => void,
  },
  taskListItem: TaskListItemModel,
}

const SubTasks = (props: SubTasksProps) => {
  const { callbacks: { addSubTask }, taskListItem } = props

  const taskListItemsPayload = useTaskListItems({
    // @ts-expect-error TS2741
    filters: {
      parent_task_id: taskListItem.id,
      sub_tasks: true,
      template_project: true,
    },
    performHttpRequests: !!taskListItem.id,
    requestOptions: {
      ...defaultRequestOptions.image,
      ...defaultRequestOptions.user,
      include_task_list_item_assignee: true,
    },
  })

  const {
    filteredTaskListItems,
    hasFilteredTaskListItems,
    loading,
  } = taskListItemsPayload

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      loading={loading}
      title="Sub Tasks"
    >
      <Box flexDirection="column">
        {filteredTaskListItems.map(subTask => (
          <SubTask key={subTask.id} taskListItem={subTask} />
        ))}
      </Box>

      <DashboardModule.Footer boxProps={{ borderTop: loading || !hasFilteredTaskListItems ? 'none' : '1px solid' }}>
        <Button
          buttonStyle="secondaryEdit"
          icon={<FontAwesomeIcon icon={faPlus} />}
          onClick={() => addSubTask()}
          marginLeft="auto"
          // @ts-expect-error TS2322
          size={['medium', 'small']}
          width={['100%', 'fit-content']}
        >
          Add Task
        </Button>
      </DashboardModule.Footer>
    </DashboardModule>
  )
}

export default SubTasks
